// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  runId: __t.u64().primaryKey().name("run_id"),
  warId: __t.u64().name("war_id"),
  battleId: __t.u64().name("battle_id"),
  side: __t.string(),
  originSid: __t.u64().name("origin_sid"),
  outpostId: __t.u64().name("outpost_id"),
  cargo: __t.string(),
  crates: __t.u8(),
  reward: __t.i64(),
  state: __t.string(),
  taker: __t.identity(),
  takenAt: __t.timestamp().name("taken_at"),
  deadline: __t.timestamp(),
  postedAt: __t.timestamp().name("posted_at"),
  doneAt: __t.timestamp().name("done_at"),
});
